import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import invoierLogo from '../../assets/images/invoier.png';
import { colors } from '../../assets/colors';
import {
    isProductionApi,
    normalizePaymentProvider,
    paymentProviderFooterContent,
    shouldShowPaymentProviderFooter
} from '../../functions/paymentProvider';
import { Line, RowView, Text } from '../../helpers';
import { IInvoice } from '../../interfaces';
import PaymentProvider from './PaymentProvider';
import TwoLogo from './TwoLogo';

type PaymentProviderFooterProps = {
    invoice: Pick<IInvoice, 'invoice_type' | 'payment_provider'>;
    style?: React.CSSProperties;
    showDivider?: boolean;
};

const FooterWrapper = styled.div`
    margin-top: 27px;
`;

const PaymentProviderFooter = ({
    invoice,
    style,
    showDivider = true
}: PaymentProviderFooterProps) => {
    const { t } = useTranslation();

    if (!shouldShowPaymentProviderFooter(invoice.invoice_type, invoice.payment_provider)) {
        return null;
    }

    const provider = normalizePaymentProvider(invoice.payment_provider);
    if (!provider) {
        return null;
    }

    const content = paymentProviderFooterContent(
        provider,
        isProductionApi(import.meta.env.VITE_API_BASE_URL)
    );

    return (
        <>
            {showDivider && <Line />}
            <FooterWrapper style={style}>
                {content.kind === 'logo' ? (
                    <RowView style={{ justifyContent: 'center' }}>
                        {content.provider === 'invoier' ? (
                            <PaymentProvider
                                logoSrc={invoierLogo}
                                logoAlt="Invoier"
                                style={{ width: '100px', marginLeft: '5px' }}
                            />
                        ) : (
                            <PaymentProvider logoAlt="Two" renderLogo={() => <TwoLogo />} />
                        )}
                    </RowView>
                ) : (
                    <RowView style={{ justifyContent: 'center', flexWrap: 'wrap' }}>
                        <Text
                            i={t('paymentProviderHandledBy', { provider: t(content.labelKey) })}
                            color={colors.dark}
                        />
                    </RowView>
                )}
            </FooterWrapper>
        </>
    );
};

export default PaymentProviderFooter;
